import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";

declare var ko: any;

export class triviaList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;

    protected initPartial() {
        this.filter      = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.resultInfos = new resultsInfo_template('resultInfo', this.getTemplateViewModel(), this.caller);
        this.pagination  = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
    }

    public getViewModelForRequest(): any {
        return {
            orderBy:            this.getTemplateViewModel().orderBy,
            orderByDirection:   this.getTemplateViewModel().orderByDirection,
            orderByAndDirection:this.getTemplateViewModel().orderByAndDirection,
            pagination:         this.getTemplateViewModel().pagination,
            filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword,
            },
        };
    }

    protected buildViewModel(): any {
        let self = this;
        return {
            triviaItems:        ko.observableArray([]),
            orderBy:            ko.observable("triviaDate"),
            orderByDirection:   ko.observable("DESC"),
            orderByAndDirection:ko.observable("triviaDate_DESC"),
            // sidebar
            sidebarRichText:    ko.observable(""),
            sidebarImageUrl:    ko.observable(""),
            sidebarImageLink:   ko.observable(""),
            // export month picker
            exportMonth:        ko.observable(new Date().toISOString().slice(0, 7)),

            onClickAdd: (data, event) => {
                self.onClickAdd();
            },
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            onClickEdit: (data, event) => {
                self.caller.viewTrivia(data.id);
            },
            onClickExport: (data, event) => {
                self.onClickExport();
            },
            onClickSaveSidebar: (data, event) => {
                self.onClickSaveSidebar();
            },
        };
    }

    protected getTemplateHtml(): string {
        return `
        <div class="list-header w-justify">
            <div class="w-left">
                <button data-bind="event: {click: onClickAdd}" class="btn secondary icon i-add" type="button">Create Trivia</button>
            </div>
            <div class="w-center">
                <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filter }"></div>
            </div>
            <div class="w-right">
                ` + this.pagination.getHtmlBuild() + `
            </div>
        </div>

        <div class="w-list-results" id="list-results">
            <table class="list-results">
                <thead>
                    <tr>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'triviaDate') }, css: { 'list-sort-desc': orderByAndDirection()=='triviaDate_DESC', 'list-sort-asc': orderByAndDirection()=='triviaDate_ASC' }">Date</span></th>
                        <th>Status</th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }">Trivia Title</span></th>
                        <th>Completions</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody data-bind="foreach: triviaItems">
                    <tr class="cursor" data-bind="click: function(data, event) { if (data.canEdit) $parent.onClickEdit(data, event); }">
                        <td><span data-bind="text: triviaDate"></span></td>
                        <td><span data-bind="text: status"></span></td>
                        <td><span data-bind="text: title"></span></td>
                        <td><span data-bind="text: completionCount"></span></td>
                        <td class="align-right" style="width: 2rem;">
                            <!-- ko if: canEdit -->
                            <button class="btn border only-icon icon i-edit" type="button" title="Edit"></button>
                            <!-- /ko -->
                            <!-- ko ifnot: canEdit -->
                            <button class="btn border only-icon icon i-view" type="button" title="View (past dates cannot be edited)" disabled></button>
                            <!-- /ko -->
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="list-footer w-justify" style="margin-top:1rem;">
            <div class="w-left">
                <label class="form-label" style="margin-right:0.5rem;">Export month:</label>
                <input type="month" class="input-text" style="width:auto;" data-bind="value: exportMonth">
                <button class="btn secondary" type="button" data-bind="event: { click: onClickExport }">Export CSV</button>
            </div>
        </div>

        <div class="w-form w-form-large" id="sidebar-section" style="margin-top:2rem;">
            <div class="form-header">
                <h3 class="form-title">Sidebar Promo</h3>
            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group">
                        <label class="form-label">Rich Text</label>
                        <textarea class="input-text" rows="6" data-bind="value: sidebarRichText"></textarea>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Image URL</label>
                        <input type="url" class="input-text" data-bind="value: sidebarImageUrl">
                    </div>
                    <div class="form-group">
                        <label class="form-label">Image Link URL</label>
                        <input type="url" class="input-text" data-bind="value: sidebarImageLink">
                    </div>
                </div>
            </div>
            <div class="form-footer">
                <button type="button" class="btn highlight" data-bind="event: { click: onClickSaveSidebar }">Save Sidebar</button>
            </div>
        </div>
        `;
    }

    protected getTemplateName(): string {
        return "triviaList-template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected getMainElementType(): string {
        return "div";
    }

    public setResultInfo(nbResults, nbPages, execTime) {
        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setTriviaItems(items: any[], brandId?: string) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const enriched = items.map((item) => {
            const d     = new Date(item.triviaDate + 'T00:00:00');
            const isPast = d < today;
            return {
                ...item,
                status:  isPast ? 'Closed' : 'Pending',
                canEdit: !isPast,
            };
        });

        this.getTemplateViewModel().triviaItems(enriched);
    }

    public setSidebarData(data: any) {
        if (!data) return;
        this.getTemplateViewModel().sidebarRichText(data.richText  || '');
        this.getTemplateViewModel().sidebarImageUrl(data.imageUrl  || '');
        this.getTemplateViewModel().sidebarImageLink(data.imageLink || '');
    }

    protected onClickAdd(): void {
        this.caller.addTrivia();
    }

    protected onClickReorder(value, data, event): void {
        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            data.orderByDirection(data.orderByDirection() === 'DESC' ? 'ASC' : 'DESC');
        } else {
            data.orderByDirection('DESC');
        }
        data.orderByAndDirection(value + '_' + data.orderByDirection());
        this.caller.triviaListReorder();
    }

    protected onClickExport(): void {
        const month = this.getTemplateViewModel().exportMonth();
        this.caller.exportTrivia(month);
    }

    protected onClickSaveSidebar(): void {
        const vm = this.getTemplateViewModel();
        this.caller.saveSidebar({
            richText:  vm.sidebarRichText(),
            imageUrl:  vm.sidebarImageUrl(),
            imageLink: vm.sidebarImageLink(),
        });
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/triviaList_template.ts